../<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>
    <b-row class="position-relative">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <b-row>
          <Alert
            :show="showFormErrorAlert"
            :message="$t('Customer\'s fixed deposit account number or account name is required')"
          />

          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
            />
          </b-col>

          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              :label="$t('Reference Number')"
              :placeholder="$t('Enter reference number')"
              type="text"
            />
          </b-col>

          <b-col md="12">
            <Button
              :label="$t('Search')"
              size="md"
              class="mt-2"
              block
              @click="handleSearch"
            />
          </b-col>
        </b-row>

      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="accountClosureRules">
            <app-collapse
              class="business-items mb-4"
              type="margin"
              accordion
            >
              <app-collapse-item
                :title="$t('FD Account Summary')"
                class="card-item"
                is-visible
              >
                <b-row>
                  <b-col md="4">
                    <InputField
                      id="account-name"
                      v-model="customer.name"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-number"
                      v-model="customer.accountNumber"
                      :label="$t('FD Account Number')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="product-name"
                      v-model="customer.productName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="branch"
                      v-model="customer.branchName"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-status"
                      v-model="customer.accountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="ledger-balance"
                      v-model="customer.ledgerBalance"
                      :label="$t('FD Ledger Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <h5 class="text-capitalize mt-3 mb-1">
                      {{ $t('Linked Account Summary') }}
                    </h5>
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-name"
                      v-model="customer.linkedAccountName"
                      :label="$t('Account Name')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="product-name"
                      v-model="customer.linkedAccountProductName"
                      :label="$t('Product Name')"
                      type="text"
                      readonly
                    />
                  </b-col>
                  <b-col md="4">
                    <InputField
                      id="available-balance"
                      v-model="customer.linkedAccountAvailableBalance"
                      :label="$t('Available Balance')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="branch"
                      v-model="customer.linkedAccountBranch"
                      :label="$t('Branch')"
                      type="text"
                      readonly
                    />
                  </b-col>

                  <b-col md="4">
                    <InputField
                      id="account-status"
                      v-model="customer.linkedAccountStatus"
                      :label="$t('Account Status')"
                      type="text"
                      readonly
                    />
                  </b-col>
                </b-row>
              </app-collapse-item>
            </app-collapse>

            <h5 class="text-capitalize mb-3">
              {{ $t('Top-up Details') }}
            </h5>
            <b-row>
              <b-col md="4">
                <InputNumberField
                  id="topup-amount"
                  v-model="customer.topUpAmount"
                  :label="$t('Top-up Amount')"
                  :error-name="$t('Top-up Amount')"
                  rules="required|integer|positive"
                  :on-input="computeNewFixedDepositAmount"
                />
              </b-col>
              <b-col md="4">
                <InputNumberField
                  id="new-fixed-deposit-amount"
                  v-model="customer.newFixedDepositAmount"
                  :label="$t('New Fixed Deposit Amount')"
                  readonly
                />
              </b-col>
              <b-col md="4">
                <InputField
                  id="instrument-number"
                  v-model="customer.instrumentNumber"
                  :label="$t('Instrument Number')"
                  type="text"
                  :error-name="$t('Instrument Number')"
                  rules="required"
                />
              </b-col>
            </b-row>
          </validation-observer>
          <div class="button-center mt-5">
            <div>
              <Button
                :label="$t('Post Top-up')"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                @click="handleSubmit"
              />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal-lg"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      :title="$t('Customer Details')"
      cancel-title-only
      @hidden="resetModal"
    >

      <b-table
        ref="customerListTable"
        select-mode="single"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        selectable
        show-empty
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>

    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BTable,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toBalance, toFormatBalance, toKobo } from '@/helpers/formatAmount'
import { closureReasonOptions } from '@/helpers/data'
import InputField from '../../../../forms/InputField.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    InputField,
    InputNumberField,
    Button,
    TablePagination,
    Alert,
    BTable,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      isDisabled: false,
      isLoading: false,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isEditable: true,
      required,
      positive,
      showSpinner: false,
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      actionType: 'save',
      sortBy: 'accountName',
      searchParams: {
        accountNumber: null,
        accountName: null,
        referenceNumber: null,
      },
      fdLiquidationData: {
        narration: '',
      },
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        maxDate: 'today',
        defaultDate: '',
      },
      accountClosureReasonOptions: closureReasonOptions,
      customerList: [],
      customer: {
        accountName: '',
        accountNumber: '',
        productName: '',
        branchName: '',
        accountStatus: '',
        ledgerBalance: '',
        fdLedgerBalance: '',
        availableBalance: '',
        linkedAccountAvailableBalance: '',
        linkedAccountBranch: '',
        linkedAccountLedgerBalance: '',
        linkedAccountName: '',
        linkedAccountProductName: '',
        linkedAccountStatus: '',
        isCurrentFinancialDate: true,
        liquidationEffectiveDate: null,
        topUpAmount: '',
        newFixedDepositAmount: '',
        instrumentNumber: '',
        formattedLedgerBalance: '',
      },
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
      ],
    }
  },
  computed: {
    totalEntries() {
      return this.customerList.length
    },
    numberOfPages() {
      return Math.floor((this.totalEntries + this.perPage - 1) / this.perPage)
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },
    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  methods: {
    ...mapActions({
      searchFDCustomerAccount: 'account/getFdAccountList',
      getFDAccountInfo: 'account/getFDAccountInformation',
      fixedDepositTopup: 'posting/fixedDepositTopup',
    }),
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchFDCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: 'VIEW_LIQUIDATE_FIXED_DEPOSIT',
          })
          const { status, data } = response
          if (status === 200 && data?.data) {
            this.customerList = data.data
            this.totalCount = data.recordCount
            this.showSpinner = false
            this.$root.$emit('bv::show::modal', 'search-modal')
          } else {
            this.customerList = []
            this.totalCount = data.recordCount
            this.$root.$emit('bv::show::modal', 'search-modal')
          }
        } else {
          this.showFormErrorAlert = true
          this.showSpinner = false
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      try {
        const [customer] = items
        this.hideModal('search-modal')
        this.showSpinner = true
        const response = await this.getFDAccountInfo({ accountNumber: customer.accountNumber, permission: 'VIEW_LIQUIDATE_FIXED_DEPOSIT' })
        const { data, status } = response
        if (status === 200) {
          this.customer = {
            ...customer,
            availableBalance: toBalance(data.data.ledgerBalance),
            ledgerBalance: toBalance(data.data.ledgerBalance),
            formattedLedgerBalance: data.data.ledgerBalance,
            fdLedgerBalance: data.data.ledgerBalance,
            linkedAccountName: data.data.linkedAccountName,
            linkedAccountProductName: data.data.linkedAccountProductName,
            linkedAccountLedgerBalance: data.data.linkedAccountLedgerBalance,
            linkedAccountAvailableBalance: toBalance(data.data.linkedAccountAvailableBalance),
            linkedAccountBranch: data.data.linkedAccountBranch,
            linkedAccountStatus: data.data.linkedAccountStatus,
          }
        }
        this.fdLiquidationData.narration = `Fixed Dep. Pre-liquidation - ${this.customer.name} / ${this.customer.liquidationAccount}`
        this.showCustomerInfo = true
        this.showSearchButton = true
        this.showBackButton = true
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    setUseCurrentFinancialDate(value) {
      if (!value) {
        this.fdLiquidationData.liquidationEffectiveDate = null
        return false
      }
      return true
    },
    computeNewFixedDepositAmount(numberValue) {
      const fdLedgerBalance = toFormatBalance(this.customer.fdLedgerBalance)
      const topupBalance = toFormatBalance(numberValue * 100)
      this.customer.newFixedDepositAmount = (Number(fdLedgerBalance) + Number(topupBalance)).toFixed(2)
    },

    async handleSubmit() {
      this.$refs.accountClosureRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to Top-up this fixed deposit account:')
          this.confirm(this.fdLiquidateAction, { text: `${areYouSure} ${this.customer.accountNumber} ?` })
        }
      })
    },

    async fdLiquidateAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const postingApprovalModel = {
          amount: this.customer.formattedLedgerBalance,
          accountName: this.customer.accountName,
          initiatedBy: '',
          approvedBy: '',
          postingType: 'FixedDepositTopUpPosting',
        }
        const formData = {
          postingApprovalModel,
          accountNumber: this.customer.accountNumber,
          topUpAmount: toKobo(this.customer.topUpAmount),
          instrumentNumber: this.customer.instrumentNumber,
          initiatedBy: this.userDetails.email,
        }
        const response = await this.fixedDepositTopup(formData)

        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.showCustomerInfo = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.resetSearchParams()
          this.alertSuccess({ text: this.$t('Your Fixed Deposit Top-up request was successful') })
          this.$router.push('fixed-deposit-top-up')
        }
        if (status === 200 && !data.isSuccessful) {
          const failedText = this.$t('Your Fixed Deposit Top-up request failed. Reason:')
          this.alertError({ text: `${failedText} ${data.message}` })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    resetInputField() {
      this.searchParams = { ...null }
      this.fdLiquidationData = { ...null }
      this.customer = { ...null }
      this.isLoading = false
      this.isDisabled = false
      this.showCustomerInfo = false
      this.showSearchButton = false
      this.showBackButton = false
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    resetSearchParams() {
      this.searchParams.accountNumber = null
      this.searchParams.accountName = null
      this.searchParams.referenceNumber = null
    },
    resetModal() {
      this.customerList = []
    },
    backNavigationAction() {
      this.$router.push({
        name: 'fixed-deposit-top-up',
      })
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}

.button-center {
  display: flex;
  justify-content: center;
}
</style>
